import React from "react";
import {
  FaMobileAlt,
  FaChartLine,
  FaBolt,
  FaShieldAlt,
  FaStore,
  FaUserShield,
} from "react-icons/fa";

const cards = [
  {
    title: "Omni-Channel Experience",
    desc: "Customers can access banking services through multiple channels (mobile apps, websites, ATMs, etc.) with a consistent experience.",
    icon: FaMobileAlt,
  },
  {
    title: "Data-Driven Personalization",
    desc: "Banks utilize customer data to deliver personalized services, such as tailored product recommendations, spending insights, and financial advice.",
    icon: FaChartLine,
  },
  {
    title: "Real-Time Transactions and Notifications",
    desc: "Customers can make transactions and receive updates instantly, enhancing the speed and convenience of banking services.",
    icon: FaBolt,
  },
  {
    title: "Enhanced Security",
    desc: "Connected banking often includes advanced security measures, such as biometric authentication and fraud detection, to protect user information and transactions.",
    icon: FaShieldAlt,
  },
  {
    title: "Merchant Services",
    desc: "Banks typically offer additional services such as fraud protection, chargeback management, and transaction reporting.",
    icon: FaStore,
  },

  {
    title: "Compliance and Security",
    desc: "Banks usually adhere to strict regulatory standards and security protocols, ensuring that transactions are secure and compliant with regulations such as PCI DSS.",
    icon: FaUserShield,
  },
];

export default function FintechReasons() {
  return (
    <section className="bg-white pb-24">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <h2 className="text-[#1b1f3b] text-3xl font-bold mb-12">
          MORE REASONS TO JOIN BINGOPAY
        </h2>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {cards.map((card, index) => {
            const Icon = card.icon;

            return (
              <div
                key={index}
                className="relative rounded-3xl p-6 h-[320px] overflow-hidden
                bg-gradient-to-b from-[#1b1f3b] to-[#0b0b16]
                shadow-xl hover:scale-[1.03] transition-transform duration-300 group"
              >
                {/* Glow */}
                <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 to-pink-500/10 opacity-0 group-hover:opacity-100 transition" />

                {/* Content */}
                <div className="relative z-10 flex flex-col h-full">

                  <h3 className="text-white text-xl font-semibold mb-3">
                    {card.title}
                  </h3>

                  <p className="text-gray-300 text-sm leading-relaxed">
                    {card.desc}
                  </p>

                  {/* Premium Icon */}
                  <div className="mt-auto self-end">
                    <div className="w-14 h-14 flex items-center justify-center
                      rounded-xl bg-white/10 backdrop-blur-md
                      group-hover:bg-indigo-500/20 transition">
                      <Icon className="text-2xl text-indigo-400 group-hover:text-white transition" />
                    </div>
                  </div>

                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
